module.exports = __webpack_public_path__ + "static/media/Logo256.f2a8c010.png";